import React from "react";
import SEO from "../../common/SEO";
import Layout from "../../common/Layout";
import ContactOne from "./ContactOne";

const Contact = () => {
  return (
    <>
      <SEO title="Contacto || Metodo Panini" />
      <Layout>

        <div className="main-content bg-white">
          {/* Start Contact Area  */}
          <div className="rwt-contact-area rn-section-gap">
            <div className="container">
              <div className="row">
                <div className="col-lg-12 mb--40"></div>
              </div>
              <h1 className="title">

                <span className="theme-gradient">Formulario de contacto</span>
              </h1>
              <ContactOne />
            </div>
          </div>
          {/* End Contact Area  */}
        </div>
      </Layout>
    </>
  );
};
export default Contact;
